var render, staticRenderFns
import script from "./ChartProjectVulnerabilities.vue?vue&type=script&lang=js&"
export * from "./ChartProjectVulnerabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cf95a7a')) {
      api.createRecord('5cf95a7a', component.options)
    } else {
      api.reload('5cf95a7a', component.options)
    }
    
  }
}
component.options.__file = "src/views/dashboard/ChartProjectVulnerabilities.vue"
export default component.exports